var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ViolationDeleteInfo',{attrs:{"is-delete":_vm.isDelete}}),_c('ViolationDeleteAnswer',{attrs:{"delete-violation":_vm.deleteViolation,"is-delete":_vm.isDelete,"toggler-delete-violation":_vm.togglerDeleteViolation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }